import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
// import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import config from 'config/api';
import Collapse from '@material-ui/core/Collapse';
import Paragrapher from "components/UI/Paragrapher/Paragrapher"
import { withRouter } from "react-router-dom";

import Card from '@material-ui/core/Card';
// import CardActionArea from '@material-ui/core/CardActionArea';
// import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import BlockButton from 'components/UI/BlockButton';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const styles = theme => ({
  root: {
    flexGrow: 1,
    // width: '90%',
    // maxWidth: '90%',
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    maxWidth: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    color: 'inherit',
    '& .MuiTypography-h2': {

    },
    '& .MuiTypography-h3': {
      fontSize: '1rem',
      paddingBottom: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    '& .MuiTypography-body1': {
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(2)
    }
  },
  card: {
    height: '100%',
    paddingTop: theme.spacing(2),
    // paddingBottom: theme.spacing(2),
    paddingBottom: theme.spacing(0),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    }
    // maxWidth: 345,
  },
  title: {
    color: (process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor),
    // textShadow: '1px 1px 2px '+theme.palette.text.shadowColor,
    textShadow: (process.env.REACT_APP_SITE === 'hemato' ? '1px 1px 2px '+theme.palette.text.shadowColor : 'none'),
    display: 'block',
    // paddingRight: '30%',
    // width: 'calc(100% - 80px)',
    width: '100%',
    // display: 'inline-block',
    // verticalAlign: 'top',
    textAlign: 'left',
    // fontSize: '1.2rem',
    // fontSize: '5rem',
    // lineHeight: '5.8rem',
    // fontSize: '4rem',
    // fontSize: '3.6rem',
    // lineHeight: '4.2rem',
    fontSize: '1.6rem',
    lineHeight: '1.9rem',

    textTransform: 'uppercase',
    // borderBottom: '2px '+theme.palette.text.titleColor+' solid',
    borderBottom: '2px '+(process.env.REACT_APP_SITE === 'neuro' ? theme.palette.primary.main : theme.palette.text.titleColor)+' solid',
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem',
      lineHeight: '1.8rem',
      // fontSize: '3.6rem',
      // lineHeight: '4.6rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.3rem',
      lineHeight: '1.5rem',
      // fontSize: '2.4rem',
      // lineHeight: '3.4rem',
      textAlign: 'center',
      paddingRight: 0,
    },
    [theme.breakpoints.down('xs')]: {
      // fontSize: '1.3rem',
      // lineHeight: '2rem',
    },

    '& em': {
      fontStyle: 'normal',
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 50,
    paddingLeft: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
  img: {
    height: 255,
    display: 'block',
    maxWidth: 400,
    overflow: 'hidden',
    width: '100%',
  },
  media: {
    height: 140,
  },
  mobileStepper: {
    marginTop: 0,
    paddingTop: 0
  }

});

class SwipeableTextMobileStepper extends React.Component {
  state = {
    activeStep: 0,
  };

  handleNext = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleStepChange = activeStep => {
    this.setState({ activeStep });
  };

  _toggleCollapse = function(id) {
    const cur = this.state['collapsed_'+id] === true ? true : false;
    // console.log(cur);
    this.setState({
      ['collapsed_'+id]: cur ? false : true
    })
  }
  render() {
    const { classes, theme, $$data } = this.props;
    const { activeStep } = this.state;
    // const maxSteps = 2;
    const maxSteps = $$data.get('news').size;
    let image, eventReplay, eventKind;
    return (
      <div className={classes.root}>
        <AutoPlaySwipeableViews
          steps={maxSteps}
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeStep}
          onChangeIndex={this.handleStepChange}
          enableMouseEvents
          slideStyle={{width: '100%'}}
          style={{maxWidth: '100%'}}
          containerStyle={{alignItems: 'flex-start'}}
          autoplay={false}
          >
          {$$data.get('news').map((step, index) => {

            image = JSON.parse(step.get('newsThumb'));
            image = image !== undefined && image !== null && image[0] !== undefined? config.newsthumbpreview.replace('{newsId}', step.get('id'))+'/'+image[0]['dest'] : undefined;
            eventReplay = step.get('newsCategory') === 'replay' && $$data !== undefined &&  $$data.get('availableEvents') !== undefined ? $$data.get('availableEvents').find($$e => $$e.get('id') === step.get('newsLinkReplay')) : undefined;
            eventKind = eventReplay !== undefined ? 'futur' : undefined;
            // console.log('eventReplay #1', eventReplay)
            eventReplay = eventReplay !== undefined  || $$data === undefined || $$data.get('replays') === undefined || $$data.get('replays').find === undefined ? eventReplay : $$data.get('replays').find($$e => $$e.get('id') === step.get('newsLinkReplay'));
            eventKind = eventKind === undefined && eventReplay !== undefined? 'replay' : eventKind;
            // console.log('eventReplay #2', eventReplay)
            // console.log('available', $$data.get('availableEvents'))
            // console.log('link', step.get('newsLinkReplay'))
            return (
              <Card key={'key_'+index} className={classes.card}>
                {
                  /*
                  console.log(Math.abs(activeStep - index) <= 2),
                  Math.abs(activeStep - index) <= 2 ? (
                  <img className={classes.img} src={step.imgPath} alt={step.label} />
                  ) : null
                  */
                  // console.log(index,activeStep, activeStep*3 <= index && index <= activeStep*3+2),
                  activeStep <= index && index <= activeStep+2 ? (
                    <div style={{backgroundImage: image === 'test' ? 'url('+image+')' : undefined}}>
                      <Choose>
                        <When condition={step.get('newsCategory') === 'info'}>
                          <CardContent>
                            <Typography variant="h3">Nouveau :</Typography>
                            <Typography variant="h2" className={classes.title}>{step.get('newsTitle')}</Typography>
                            <Typography variant="body1">{step.get('newsShortDescription')}</Typography>
                            <If condition={this.state['collapsed_'+step.get('id')] !== true && step.get('newsDescription') !== undefined && step.get('newsDescription') !== ''}>
                              <Button variant="contained" color="secondary" size="large" onClick={(e) => this._toggleCollapse(step.get('id'))}>Voir plus</Button>
                            </If>
                            <If condition={step.get('newsDescription') != ''}>
                              <Collapse in={ this.state['collapsed_'+step.get('id')]} timeout="auto" unmountOnExit collapsedHeight={'50px'}>
                                <CardContent>
                                  <Typography variant="body1" component="div"><Paragrapher text={step.get('newsDescription')} pretty={true} element={'div'}/></Typography>
                                  <Button variant="contained" color="secondary" size="large" onClick={(e) => this._toggleCollapse(step.get('id'))}>Fermer</Button>
                                </CardContent>
                              </Collapse>
                            </If>

                          </CardContent>

                        </When>
                        <When condition={step.get('newsCategory') === 'replay'}>
                          <If condition={image && image[0] && image[0] === 'test'}>
                            <CardMedia
                              className={classes.media}
                              image={config.newsthumbpreview.replace('{newsId}', step.get('id'))+'/'+image[0]['dest']}
                              title={step.get('newsTitle')}
                              />
                          </If>
                          <CardContent>
                            <If condition={eventKind === 'futur'}>
                              <Typography variant="h3">Bientôt disponible en replay</Typography>
                              <Typography variant="h2"  className={classes.title}><Paragrapher  prettyfy={true} text={step.get('newsTitle')} element="div"/></Typography>
                              <Typography variant="h4"><Paragrapher  prettyfy={true} text={eventReplay.get('eventTitle')} element="div"/></Typography>
                              {/*                          <Typography variant="body1" component="div"><Paragrapher text={eventReplay.get('eventDescription')} prettyfy={true} element={'div'}/></Typography>*/}
                              <Button variant="contained" color="secondary" size="large" to={step.get('newsLinkExternal')} onClick={(e) => {e.preventDefault(); this.props.history.push(step.get('newsLinkExternal'))}} disabled={true}>Bientot disponible</Button>
                            </If>
                            <If condition={eventKind !== 'futur'}>
                              <Typography variant="h3">Nouveau replay en ligne</Typography>
                              <Typography variant="h2" className={classes.title}><Paragrapher  prettyfy={true} text={step.get('newsTitle')} element="div"/></Typography>
                              <Typography variant="h4" ><Paragrapher  prettyfy={true} text={eventReplay.get('eventTitle')} element="div"/></Typography>
                              <Button variant="contained" color="secondary" size="large" to={step.get('newsLinkExternal')} onClick={(e) => {e.preventDefault(); this.props.history.push(step.get('newsLinkExternal'))}}>Voir le replay</Button>
                            </If>

                          </CardContent>


                        </When>
                        {/*  <When condition={step.get('newsCategory') === 'number1'}>
                        <Typography variant="h3" classes={{root: classes.headline}}>{step.get('newsHeadline')}</Typography>
                        <Typography variant="h4" classes={{root: classes.title}}>{step.get('newsTitle')}</Typography>

                        <Typography variant="body1">{step.get('newsShortDescription')}</Typography>
                        <If condition={step.get('newsDescription') != ''}>
                        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit collapsedHeight={'50px'}>
                        <CardContent>
                        <Typography variant="body1">{step.get('newsDescription')}</Typography>
                        </CardContent>
                        </Collapse>
                        </If>
                        </When>*/}
                      </Choose>
                    </div>
                  ) : null
                }


              </Card>
            )}).toArray()}
          </AutoPlaySwipeableViews>
          <MobileStepper
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            className={classes.mobileStepper}
            nextButton={
              <IconButton size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
              </IconButton>
            }
            backButton={
              <IconButton size="small" onClick={this.handleBack} disabled={activeStep === 0}>
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              </IconButton>
            }
            />
        </div>
      );
    }
  }

  SwipeableTextMobileStepper.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
  };

  export default withRouter(withStyles(styles, { withTheme: true })(SwipeableTextMobileStepper));



// WEBPACK FOOTER //
// ./src/components/UI/News/News.jsx